@if (station) {
  <div
    class="flex gap-2 cursor-pointer items-start" [class]="direction"
    (click)="onStationClick.emit(station)"
    >
    <ng-icon name="station" class="text-2xl colored-icon" />
    <div class="flex flex-col flex-1">
      @if (stationName) {
        <span class="font-semibold text-sm">{{
          stationName
        }}</span>
      }
      @if (station.stopcode) {
        <span class="font-normal text-[#5C748F]"
          [ngStyle]="stopcodeColor ? { 'color': stopcodeColor } : {}">
          {{ stationCodeText }}: {{ station.stopcode }}
        </span>
      }
    </div>
  </div>
}
